(function () {
  if (window.ProductPersonalisation) return;

  const ProductPersonalisation = {
    getCharLimit(font) {
      if (font === 'Cursive') return 15;
      if (font === 'Bold') return 12;
      if (font === 'Shadow') return 3;
      return 12;
    },

    init(context) {
      const scope = context || document;
      const roots = scope.querySelectorAll('[data-pp-root]:not([data-pp-init="true"])');
      roots.forEach((root) => this.initRoot(root));
    },

    initRoot(root) {
      if (!root) return;
      root.setAttribute('data-pp-init', 'true');

      this.initGenericBlock(root);
      this.initPassportBlock(root);
      this.initLuggageBlock(root);
      this.initFormValidation(root);
    },

    initGenericBlock(root) {
      const generic = root.querySelector('[data-pp-generic]');
      if (!generic) return;

      const input = generic.querySelector('.pp-input-field');
      const font = generic.querySelector('.pp-font-selector');
      const position = generic.querySelector('.pp-position-selector');
      const overlay = generic.querySelector('[data-pp-overlay]');
      const error = generic.querySelector('.pp-input-error-message');

      if (!input || !font || !position || !overlay || !error) return;

      let previousFont = font.value || '';

      const updateCharacterLimit = () => {
        const charLimit = font.value === 'pp-font-gill-sans' ? 2 : 10;
        input.setAttribute('maxlength', charLimit);
        input.setAttribute('placeholder', 'Character Limit: ' + charLimit);

        if (input.value.length > charLimit) {
          input.value = input.value.slice(0, charLimit);
        }

        overlay.textContent = input.value;
      };

      const updateOverlayClass = () => {
        const positionClass = position.value === 'bottom' ? 'pp-bottom' : 'pp-center';
        overlay.className = 'pp-text-overlay ' + positionClass + ' ' + font.value;
      };

      const validate = () => {
        if (input.value.trim() === '') {
          input.classList.add('pp-input-error');
          error.style.display = 'block';
          return false;
        } else {
          input.classList.remove('pp-input-error');
          error.style.display = 'none';
          return true;
        }
      };

      font.addEventListener('change', () => {
        const selectedFont = font.value;

        const switchedGillMode =
          (previousFont === 'pp-font-gill-sans' && selectedFont !== 'pp-font-gill-sans') ||
          (previousFont !== 'pp-font-gill-sans' && selectedFont === 'pp-font-gill-sans');

        if (switchedGillMode) {
          input.value = '';
          overlay.textContent = '';
        }

        updateOverlayClass();
        updateCharacterLimit();
        validate();
        previousFont = selectedFont;
      });

      input.addEventListener('input', () => {
        if (font.value === 'pp-font-gill-sans') {
          input.value = input.value.slice(0, 2);
        }

        overlay.textContent = input.value;
        validate();
      });

      position.addEventListener('change', updateOverlayClass);
      input.addEventListener('blur', validate);

      updateOverlayClass();
      updateCharacterLimit();
    },

    initPassportBlock(root) {
      const block = root.querySelector('[data-pp-passport]');
      if (!block) return;

      const fontSelect = block.querySelector('.pp-passport-font');
      const textInput = block.querySelector('.pp-passport-text');
      const limitText = block.querySelector('.pp-passport-limit');

      if (!fontSelect || !textInput || !limitText) return;

      const update = () => {
        const limit = this.getCharLimit(fontSelect.value);
        textInput.setAttribute('maxlength', limit);
        limitText.textContent = limit;

        if (textInput.value.length > limit) {
          textInput.value = textInput.value.slice(0, limit);
        }
      };

      fontSelect.addEventListener('change', update);
      textInput.addEventListener('input', () => {
        const limit = this.getCharLimit(fontSelect.value);
        if (textInput.value.length > limit) {
          textInput.value = textInput.value.slice(0, limit);
        }
      });

      update();
    },

    initLuggageBlock(root) {
      const block = root.querySelector('[data-pp-luggage]');
      if (!block) return;

      const initOne = (fontSelector, textInput, limitEl) => {
        if (!fontSelector || !textInput || !limitEl) return;

        const update = () => {
          const limit = this.getCharLimit(fontSelector.value);
          textInput.setAttribute('maxlength', limit);
          limitEl.textContent = limit;

          if (textInput.value.length > limit) {
            textInput.value = textInput.value.slice(0, limit);
          }
        };

        fontSelector.addEventListener('change', update);
        textInput.addEventListener('input', () => {
          const limit = this.getCharLimit(fontSelector.value);
          if (textInput.value.length > limit) {
            textInput.value = textInput.value.slice(0, limit);
          }
        });

        update();
      };

      initOne(
        block.querySelector('.pp-luggage-font-1'),
        block.querySelector('.pp-luggage-text-1'),
        block.querySelector('.pp-luggage-limit-1')
      );

      initOne(
        block.querySelector('.pp-luggage-font-2'),
        block.querySelector('.pp-luggage-text-2'),
        block.querySelector('.pp-luggage-limit-2')
      );
    },

    initFormValidation(root) {
      const form = root.closest('form');
      if (!form || form.dataset.ppValidationBound === 'true') return;

      form.dataset.ppValidationBound = 'true';

      form.addEventListener('submit', function (event) {
        let hasError = false;

        form.querySelectorAll('[required]').forEach((field) => {
          const value = typeof field.value === 'string' ? field.value.trim() : '';
          if (!value) {
            field.classList.add('pp-input-error');
            hasError = true;
          } else {
            field.classList.remove('pp-input-error');
          }
        });

        if (hasError) {
          event.preventDefault();
          const firstError = form.querySelector('.pp-input-error');
          if (firstError) firstError.focus();
        }
      });
    }
  };

  window.ProductPersonalisation = ProductPersonalisation;

  const boot = (context) => {
    ProductPersonalisation.init(context || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('quick-view:loaded', function (event) {
    boot(event.target || document);
  });

  document.addEventListener('modal:opened', function (event) {
    boot(event.target || document);
  });

  document.addEventListener('theme:modal:open', function (event) {
    boot(event.target || document);
  });

  document.addEventListener('click', function () {
    setTimeout(function () {
      boot(document);
    }, 250);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('[data-pp-root]') || node.querySelector('[data-pp-root]')) {
          boot(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();